<template>
  <div class="p-3 bg-white">
    <div id="companyWorktimeEditFormDataContainer" class="vs-con-loading__container">
      <shared-company-worktime-edit
        @success="onUpdateSuccess"
      ></shared-company-worktime-edit>
      <div class="text-center">
        <vs-button id="updateCompanyWorktimeButton" class="m-2" color="primary" type="filled" @click.prevent="onUpdate">{{ $t('save') }}</vs-button>
        <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="onCancelEdit">{{ $t('cancel') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import SharedCompanyWorktimeEdit from '@/views/Shared/CompanyWorktime/Edit'
import { EventBus } from '@/../eventbus'
export default {
  name: 'Window.Company.Worktime.Edit',
  components: {
    SharedCompanyWorktimeEdit
  },
  mounted () {
    EventBus.$emit('initCompanyWorktimeGetFormData')
  },
  methods: {
    onUpdate () {
      EventBus.$emit('initCompanyWorktimeUpdate')
    },
    onUpdateSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_worktime_display')
      window.close()
    },
    onCancelEdit () {
      this.$windowOpenerHelper.notifyOpener('reload_worktime_display')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
